import Vue from 'vue';
import {isServer} from '@vue-storefront/core/helpers';

if (!isServer) {
  const load = name => () => import(/* webpackChunkName: "leaflet" */ 'vue2-leaflet').then(m => m[name]);

  Vue.component('l-circle', load('LCircle'));
  Vue.component('l-geo-json', load('LGeoJson'));
  Vue.component('l-icon-default', load('LIconDefault'));
  Vue.component('l-layer-group', load('LLayerGroup'));
  Vue.component('l-map', load('LMap'));
  Vue.component('l-marker', load('LMarker'));
  Vue.component('l-popup', load('LPopup'));
  Vue.component('l-tile-layer', load('LTileLayer'));
  Vue.component('l-tooltip', load('LTooltip'));
  Vue.component('l-icon', load('LIcon'));
}
